export default __webpack_public_path__ + "static/dc-mobile-807ba85e7a1e52f69919bb87142e301f.png";